import BrandMgmtApp from './BrandMgmtApp';
import LegacyApp from './LegacyApp';

function App() {
  const isBrandMgmt = window.location.pathname.startsWith('/map');
  return (isBrandMgmt ? <BrandMgmtApp /> : <LegacyApp />);
}

export default App;
